import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Users } from "lucide-react";
import CommonChip from "../../../common_components/CommonChip";
const RecipientSection = ({ title, users, colorIndex = 0, }) => {
    const getKey = (user, idx) => {
        if ('_id' in user && user._id)
            return user._id;
        return `user-${idx}`;
    };
    return (_jsxs(Box, { className: "email-configuration-expanded-section", children: [_jsxs(Box, { className: "email-configuration-expanded-section-header", children: [_jsx(Box, { component: "span", className: "email-configuration-expanded-section-header-icon", children: _jsx(Users, { size: 14 }) }), _jsxs(Typography, { className: "email-configuration-expanded-section-title", children: [title, " (", users.length, ")"] })] }), _jsx(Box, { className: "email-configuration-expanded-section-content", children: users.map((user, idx) => (_jsx(CommonChip, { label: `${user.first_name} ${user.last_name} (${user.email || ''})`, renderType: "tag", index: colorIndex + idx }, getKey(user, idx)))) })] }));
};
const ExpandedRow = ({ configuration }) => {
    const additionalRecipients = configuration.additional_user_ids || [];
    const ccRecipients = configuration.cc || [];
    const bccRecipients = configuration.bcc || [];
    const sections = [
        { key: 'additional', title: 'Additional Recipients', users: additionalRecipients, colorIndex: 0 },
        { key: 'cc', title: 'CC', users: ccRecipients, colorIndex: 3 },
        { key: 'bcc', title: 'BCC', users: bccRecipients, colorIndex: 6 },
    ].filter(s => s.users.length > 0);
    if (sections.length === 0) {
        return (_jsx(Box, { className: "email-configuration-expanded-empty", children: _jsx(Typography, { className: "email-configuration-expanded-empty-text", children: "No additional recipients, CC, or BCC configured for this notification" }) }));
    }
    return (_jsx(Box, { className: "email-configuration-expanded-row", children: sections.map(s => (_jsx(RecipientSection, { title: s.title, users: s.users, colorIndex: s.colorIndex }, s.key))) }));
};
export default ExpandedRow;
